import { render } from "./SelectDeliveryMode.vue?vue&type=template&id=2d7812aa"
import script from "./SelectDeliveryMode.vue?vue&type=script&lang=js"
export * from "./SelectDeliveryMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__